// "Show more" pagination for the Blog/Analytics archives, backed by
// inc/ajax/load-more.php.
export function initLoadMore() {
	const trigger = document.querySelector('[data-load-more-trigger]');
	if (!trigger) return;

	const container = document.querySelector('[data-load-more-container]');
	const postType = container.dataset.postType;
	const category = container.dataset.category || '';
	const lang = container.dataset.lang || '';

	trigger.addEventListener('click', async () => {
		const nextPage = parseInt(container.dataset.page, 10) + 1;
		trigger.disabled = true;

		try {
			const formData = new FormData();
			formData.set('action', 'igs_load_more');
			formData.set('nonce', window.igsData.nonce);
			formData.set('post_type', postType);
			formData.set('category', category);
			formData.set('lang', lang);
			formData.set('page', nextPage);

			const response = await fetch(window.igsData.ajaxUrl, { method: 'POST', body: formData });
			const result = await response.json();

			if (result.success) {
				container.insertAdjacentHTML('beforeend', result.data.html);
				container.dataset.page = nextPage;
				if (!result.data.hasMore) {
					trigger.remove();
				}
			}
		} finally {
			trigger.disabled = false;
		}
	});
}
